(() => {
  const params = new URLSearchParams(location.search);
  const campaign = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
    const value = params.get(key);
    if (value && /^[a-z0-9 _.-]{1,100}$/i.test(value)) campaign[key] = value;
  }
  function publish(name, details) {
    if (!window.Shopify?.analytics?.publish) return;
    try {
      const result = window.Shopify.analytics.publish(`cws:${name}`, { page_path: location.pathname, ...campaign, ...details });
      if (result?.catch) result.catch(() => {});
    } catch (_) {}
  }
  document.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.href);
    if (Object.keys(campaign).length && (url.origin === location.origin || url.hostname === 'whop.com')) {
      for (const [key, value] of Object.entries(campaign)) if (!url.searchParams.has(key)) url.searchParams.set(key, value);
      link.href = url.href;
    }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    let action = link.dataset.cwsEvent;
    if (!action && url.hostname === 'whop.com' && url.pathname.includes('/checkout/')) action = 'community_checkout';
    if (!action && url.pathname === '/pages/seers-seminar') action = 'seminar_page';
    if (!action && url.pathname === '/pages/private-coaching') action = 'coaching_page';
    if (!action && url.hash === '#apply') action = 'coaching_apply';
    if (!action && url.pathname.endsWith('Pattern-to-Practice-Map.pdf')) action = 'reflection_download';
    if (action) publish('cta_clicked', { action, destination_host: url.hostname, destination_path: url.pathname });
  });
  const form = document.getElementById('PrivateCoachingForm');
  if (form) {
    const source = form.querySelector('[name="contact[Source]"]');
    const campaignField = form.querySelector('[name="contact[Campaign]"]');
    if (source) source.value = campaign.utm_source || 'Unknown';
    if (campaignField) campaignField.value = campaign.utm_campaign || 'Unknown';
    form.addEventListener('submit', () => publish('application_submitted', { form: 'private_coaching', status: 'submitted_not_confirmed' }));
  }
})();
